import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'toResourceUrl'})
export class ResourceMultimediaPipe implements PipeTransform {

  transform(id: number) {
    let baseUrl = '/commande-materiel/api/';
    let serviceUrl = baseUrl + 'ressourcemultimedia/';
    return serviceUrl + id;
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/common/utils/image/resource.multimedia.pipe.ts